<template>
  <div>
    <div class="f x lg--mb-5 sm--mb-4 fw">
      <ValidationProvider
        name="first name"
        rules="required|alpha_dash"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="form.first_name"
          type="text"
          name="address[first_name]"
          :required="true"
          label="First Name"
          containerClass="lg--f-1 sm--x sm--mb-4"
          :error="errors && errors[0]"
        />
      </ValidationProvider>

      <ValidationProvider
        name="last name"
        rules="required|alpha_dash"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="form.last_name"
          type="text"
          name="address[last_name]"
          :required="true"
          label="Last Name"
          :error="errors && errors[0]"
          containerClass="lg--f-1 sm--x lg--pl-4"
        />
      </ValidationProvider>
    </div>

    <div class="lg--mb-5 sm--mb-4">
      <ValidationProvider
        name="address"
        rules="required"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="form.address1"
          type="text"
          name="address[address1]"
          :required="true"
          label="Address 1"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
    </div>

    <div class="lg--mb-5 sm--mb-4">
      <ValidationProvider
        name="address 2"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="form.address2"
          type="text"
          name="address[address2]"
          label="Address 2"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
    </div>

    <div class="f x lg--mb-5 sm--mb-4 fw">
      <ValidationProvider
        name="city"
        rules="required"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="form.city"
          type="text"
          name="address[city]"
          :required="true"
          label="City"
          :error="errors && errors[0]"
          containerClass="lg--f-1 sm--x sm--mb-4"
        />
      </ValidationProvider>

      <div class="lg--f-1 sm--x lg--pl-4">
        <slot name="country"></slot>
      </div>
    </div>

    <slot name="province"></slot>

    <div class="f x lg--mb-5 sm--mb-4 fw">
      <ValidationProvider
        name="zip code"
        rules="required|alpha_num"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="form.zip"
          type="text"
          name="address[zip]"
          :required="true"
          label="Zip Code"
          :error="errors && errors[0]"
          containerClass="lg--f-1 sm--x sm--mb-4"
        />
      </ValidationProvider>

      <ValidationProvider
        name="phone"
        rules="required|alpha_num"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="form.phone"
          type="required|alpha_num"
          name="address[phone]"
          :required="true"
          label="Phone"
          :error="errors && errors[0]"
          containerClass="lg--f-1 sm--x lg--pl-4"
        />
      </ValidationProvider>
    </div>

    <input
      class="submit-button plaid-l fs-12 address-form-submit"
      value="SAVE"
      type="submit"
    />
  </div>
</template>

<script>
export default {
  name: "addresses-edit-form",
  props: {
    form: Object,
  },
  methods: {
    selectDefaultOption(selector, defaultValue) {
      for (var i, j = 0; (i = selector.options[j]); j++) {
        if (i.value === defaultValue) {
          selector.selectedIndex = j;
          break;
        }
      }
    },
  },
  mounted() {
    const countrySelector = document.querySelector(
      `#AddressCountry_${this.form.id}`
    );
    const provinceSelector = document.querySelector(
      `#AddressProvince_${this.form.id}`
    );

    const defaultCheckbox = document.querySelector(
      `#address_default_address_${this.form.id}`
    );

    if (this.form.default == this.form.id) {
      defaultCheckbox.checked = "true";
    }

    const defaultCountry = countrySelector.getAttribute("data-default")
      ? countrySelector.getAttribute("data-default")
      : countrySelector.options[0].value;
    const defaultProvince = provinceSelector.getAttribute("data-default");

    const countryPlaceholder = document.querySelector('option[value="---"]');
    countryPlaceholder.innerHTML = "Country";
    countryPlaceholder.setAttribute("disabled", true);

    const component = this;

    new Shopify.CountryProvinceSelector(
      `AddressCountry_${component.form.id}`,
      `AddressProvince_${component.form.id}`,
      {
        hideElement: `AddressProvinceContainer_${component.form.id}`,
      }
    );

    this.selectDefaultOption(countrySelector, defaultCountry);
    this.selectDefaultOption(provinceSelector, defaultProvince);
  },
};
</script>
